/**
 * Environment-specific configuration
 * Reads from process.env variables set in .env file
 */
export default {
  host:
    process.env.CAPE_API_HOST || "https://cape.ipc.be/cape-reporting-api-web",
  useStubbedEndpoints: process.env.USE_STUBBED_ENDPOINTS === "true",
  // Serves the download from the streaming endpoint instead of the batch loop. Off until the
  // NGS /raw endpoint it depends on is deployed.
  useStreamedReportDownload: process.env.USE_STREAMED_REPORT_DOWNLOAD === "true",
  applications: {
    assetManagement: process.env.ASSET_MANAGEMENT_URL || "https://amt.ipc.be/",
    paperfree: process.env.PAPERFREE_URL || "https://pf.ipc.be/",
    atatSystem:
      process.env.ATAT_SYSTEM_URL || "https://atat.ipc.be/atat-fe-api-web/#",
  },
  maxRowsForExcelExport: parseInt(
    process.env.MAX_ROWS_FOR_EXCEL_EXPORT || "50000",
    10
  ),
  perReportConfiguration: [
    {
      reportCode: "ITEM_OVERVIEW_V1_200",
      config: {
        maxRowsForExcelExport: 30000,
      },
    },
  ],
};
